<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 角色权限
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <section style="padding: 10px">
            <el-row :gutter="10">
                <el-col :span="6" class="toolbar roles">
                    <el-card>
                        <template #header>
                            <div class="clearfix">
                                <span>角色</span>
                                <el-button :loading="loadingRoles" type="text" style="float: right; padding: 3px 0" @click="getRoles">刷新</el-button>
                            </div>
                        </template>
                        <div v-for="o in roles" :key="o.id" :class="o.id == roleId ? 'active' : ''" class="item role-item" @click="roleSelect(o.id)">
                            <span>{{ o.name }}</span>
                            <span style="float: right">{{ o.description }}</span>
                        </div>
                    </el-card>
                </el-col>
                <el-col :span="18" class="toolbar perms">
                    <el-card>
                        <template #header>
                            <div class="clearfix">
                                <span>权限</span>
                                <el-button :loading="loadingPermissions" type="text" style="float: right" @click="saveEdit" :disabled="disabledSave">保存</el-button>
                                <el-button :loading="loadingPermissions" type="text" style="float: right; padding-right: 10px" @click="getPermissions">刷新</el-button>
                            </div>
                        </template>
                        <el-table
                            :data="permissionTree"
                            border
                            class="table"
                            ref="multipleTable"
                            element-loading-text="玩命加载中..."
                            v-loading="loading"
                            row-key="id"
                            header-cell-class-name="table-header"
                            @selection-change="handleSelectionChange"
                            :default-expand-all="true"
                            :expand-row-keys="expandRowKeys"
                            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                            highlight-current-row
                            style="width: 100%"
                            @select-all="onSelectAll"
                            @select="onSelect"
                        >
                            <el-table-column type="selection" width="55" align="center"></el-table-column>
                            <el-table-column prop="title" label="名称"></el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
            </el-row>
        </section>
    </div>
</template>

<script>
import { SortField, toTree } from '../../utils/helper';
import { formatTime, treeToList, listToTree, getTreeParents, getTreeParentsWithSelf } from '../../utils';
export default {
    name: 'rolePermission',
    data: function () {
        return {
            headTitle: '',
            isadd: false,
            editVisible: false,
            roleId: 0,
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            expandRowKeys: [],
            loading: false,
            query: {
                Field1: '',
                Field2: '',
                Field3: ''
            },
            loadingPermissions: false,
            roles: [],
            permissionTree: [],
            checkedPermissions: [],
            loadingRoles: false
        };
    },
    created() {
        this.getPermissions();
        this.getRoles();
    },
    computed: {
        disabledSave() {
            return !(this.roleId > 0 && this.checkedPermissions.length > 0);
        }
    },
    methods: {
        roleSelect(id) {
            this.roleId = id;
            this.onSelectAll([]);
            this.getRolePermission();
        },
        // 获取角色权限
        async getRolePermission() {
            if (!this.roleId > 0) {
                return;
            }
            this.$zybhttp
                .post('RolePermission/GetRolePerissionList', { Field1: this.roleId + '' })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        this.loadingPermissions = false;
                        const permissionIds = res.data.list;
                        const rows = treeToList(this.permissionTree);
                        rows.forEach((row) => {
                            const checked = permissionIds.includes(row.id);
                            this.$refs.multipleTable.toggleRowSelection(row, checked);
                        });
                        this.checkedPermissions = this.$refs.multipleTable.selection.map((s) => {
                            return s.id;
                        });
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getRoles() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('role/GetList', { Field3: userInfo.id + '' })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        this.roles = newdata;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        saveEdit() {
            if (!(this.roleId > 0)) {
                this.$notify.warning('请选择角色！');
                return;
            }
            if (!(this.checkedPermissions.length > 0)) {
                this.$notify.warning('请选择菜单！');
                return;
            }

            const permissionIds = [...this.checkedPermissions];
            const para = { permissionIds, roleId: this.roleId };

            this.$zybhttp
                .post('RolePermission/RolePermissionSave', para)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(res.data.msg);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        indexMethod(index) {
            return index + 1;
        },
        onSelectAll: function (selection) {
            const selections = treeToList(selection);
            const rows = treeToList(this.viewTree);
            const checked = selections.length === rows.length;
            rows.forEach((row) => {
                this.$refs.multipleTable.toggleRowSelection(row, checked);
            });

            this.sels = this.$refs.multipleTable.selection;
        },
        onSelect: function (selection, row) {
            const checked = selection.some((s) => s.id === row.id);
            if (row.children && row.children.length > 0) {
                const rows = treeToList(row.children);
                rows.forEach((r) => {
                    this.$refs.multipleTable.toggleRowSelection(r, checked);
                });
            }

            const parents = getTreeParentsWithSelf(this.permissionTree, row.id);
            parents.forEach((parent) => {
                const checked = this.checkedPermissions.includes(parent.id);
                if (!checked) {
                    this.$refs.multipleTable.toggleRowSelection(parent, true);
                }
            });

            this.checkedPermissions = this.$refs.multipleTable.selection.map((s) => {
                return s.id;
            });
        },
        // 获取权限树
        async getPermissions() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Menu/GetMenuList', { Field2: userInfo.id + '' })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('sort', 'asc'));
                        newdata = newdata.map((x) => {
                            x.enabledFt = x.enabled == '1';
                            return x;
                        }, []);
                        const keys = newdata.filter((l) => l.parentId === 9999).map((l) => l.id + '');
                        this.expandRowKeys = keys;
                        // var idd = this.MenuCarding(newdata);
                        var idd = listToTree(newdata);
                        this.permissionTree = idd;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        }
    }
};
</script>

<style scoped>
.role-item {
    font-size: 14px;
    cursor: pointer;
    padding: 10px;
}

.role-item.active {
    background: #ebf5ff;
}

.role-item:hover {
    background: #ebf5ff;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}
.clearfix:after {
    clear: both;
}

.save ::v-deep [_button] {
    padding: 3px 0px;
}

.table {
    width: 100%;
    font-size: 14px;
}
</style>
